import React from 'react'
import { any, async, fromJSX, Updater, Widget } from 'widgets-for-react'
import { SearchLayout } from './searchLayout'
import { searchPageStateUpdaters, SearchResult, SearchState } from './searchState'

export const searchWidget = (
  state: SearchState
): Widget<Updater<SearchState>> =>
  any([
    async<SearchResult>(state.result).map(
      searchPageStateUpdaters.updateSearchResult
    ),
    fromJSX(() => (
      <SearchLayout {...state} />
    ))
  ])